import { Duration } from "luxon";
import { useEffect, useState } from "react";

/** A clock that ticks once a minute, so relative times in the table age together without re-rendering per second. */
export function useMinuteClock(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), Duration.fromObject({ minutes: 1 }).toMillis());
    return () => clearInterval(timer);
  }, []);
  return now;
}
